<div class="modal-header">
  <h5 class="modal-title">Upload application</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<ml-mdm-upload-spinner [status]="uploadProgress ? uploadProgress.progress : 0"
                       [isLoading]="uploadProgress.isLoading">
  <div class="modal-body">
    <form>
      <div>
        <label class="form-label pe-2"
               for="softwarePackage">Application package</label>
        <input ngbAutofocus
               #uploadTest
               id="softwarePackage"
               type="file"
               class="form-control-file"
               (change)="onFileChange($event)" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="submit"
            class="btn btn-primary align-self-end"
            (click)="onSubmit()">
      <fa-icon icon="file-upload"></fa-icon>
      <span class="ms-2"
            i18n>Upload</span>
    </button>
  </div>
</ml-mdm-upload-spinner>